import React from "react";
import { Stack, Hidden } from "@mui/material";

import { FooterOne } from "./FooterOne";
import { FooterTwo } from "./FooterTwo";
import { FooterThree } from "./FooterThree";

export const MobileFooter = ({ translate }) => {
  return (
    <Stack direction="column" justifyContent="space-around" p={4}>
      <Stack direction="column" flex={1} p={2}>
        <FooterOne translate={translate} />
      </Stack>
      <Hidden smDown>
        <Stack
          direction="row"
          flex={1}
          justifyContent="space-around"
          spacing={1}
        >
          <FooterTwo translate={translate} />
          <FooterThree translate={translate} />
        </Stack>
      </Hidden>
      <Hidden smUp>
        <Stack direction="column" spacing={1} m={0}>
          <FooterTwo translate={translate} />
          <FooterThree translate={translate} />
        </Stack>
      </Hidden>
    </Stack>
  );
};
